require('./$.set-species')('Array');


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/babel-core/~/core-js/modules/es6.array.species.js
 ** module id = 437
 ** module chunks = 0
 **/